(function () {
  var root = document.querySelector('[data-bib-conversion]');

  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  var productNodes = Array.from(root.querySelectorAll('[data-bib-product]'));
  var productSelect = root.querySelector('[data-bib-product-select]');
  var weightInput = root.querySelector('[data-bib-weight]');
  var quickWeightSelect = root.querySelector('[data-bib-quick-weight]');
  var result = root.querySelector('[data-bib-result]');
  var tableBody = root.querySelector('[data-bib-reference-body]');
  var tableCaption = root.querySelector('[data-bib-table-caption]');
  var selectedMedia = root.querySelector('[data-bib-selected-media]');
  var selectedImage = root.querySelector('[data-bib-selected-image]');
  var selectedVendor = root.querySelector('[data-bib-selected-vendor]');
  var selectedTitle = root.querySelector('[data-bib-selected-title]');
  var selectedAvailability = root.querySelector('[data-bib-selected-availability]');
  var selectedDataStatus = root.querySelector('[data-bib-selected-data-status]');
  var selectedLink = root.querySelector('[data-bib-selected-link]');
  var fallbackUrl = root.dataset.fallbackUrl || '';
  var products = productNodes.map(function (node) {
    var points = [];

    try {
      points = JSON.parse(node.dataset.conversionPoints || '[]');
    } catch (error) {
      points = [];
    }

    points = points
      .map(function (point) {
        return {
          weight: Number(point.weight_kg ?? point.weight ?? point.kg),
          litres: Number(point.litres ?? point.volume_l ?? point.volume),
        };
      })
      .filter(function (point) {
        return Number.isFinite(point.weight) && Number.isFinite(point.litres);
      })
      .sort(function (a, b) {
        return a.weight - b.weight;
      });

    return {
      node: node,
      handle: node.dataset.handle,
      title: node.dataset.title || 'Selected product',
      vendor: node.dataset.vendor || '',
      url: node.dataset.url || '',
      image: node.dataset.image || '',
      imageAlt: node.dataset.imageAlt || node.dataset.title || '',
      availability: node.dataset.availability || 'Availability not confirmed',
      hasProduct: node.dataset.hasProduct === 'true',
      hasData: node.dataset.hasConversionData === 'true' && points.length > 0,
      points: points,
    };
  });
  var productsByHandle = new Map(
    products.map(function (product) {
      return [product.handle, product];
    }),
  );

  function formatNumber(value) {
    var rounded = Math.round(value * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  }

  function setResult(state, message) {
    result.dataset.state = state;
    result.textContent = message;
  }

  function addCell(row, value) {
    var cell = document.createElement('td');
    cell.textContent = value;
    row.appendChild(cell);
  }

  function renderReference(product) {
    tableBody.textContent = '';
    quickWeightSelect.textContent = '';
    var defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = product.hasData ? 'Choose a table value' : 'No approved data available';
    quickWeightSelect.appendChild(defaultOption);

    if (!product.hasData) {
      var emptyRow = document.createElement('tr');
      var emptyCell = document.createElement('td');
      emptyCell.colSpan = 2;
      emptyCell.textContent = 'Conversion data unavailable for this product.';
      emptyRow.appendChild(emptyCell);
      tableBody.appendChild(emptyRow);
      tableCaption.textContent = 'Conversion data unavailable for ' + product.title;
      quickWeightSelect.disabled = true;
      return;
    }

    quickWeightSelect.disabled = false;
    product.points.forEach(function (point) {
      var row = document.createElement('tr');
      addCell(row, point.weight.toFixed(2));
      addCell(row, formatNumber(point.litres));
      tableBody.appendChild(row);

      var option = document.createElement('option');
      option.value = point.weight;
      option.textContent = point.weight.toFixed(2) + ' kg — ' + formatNumber(point.litres) + ' litres';
      quickWeightSelect.appendChild(option);
    });
    tableCaption.textContent = 'Weight and estimated volume for ' + product.title;
  }

  function calculate(product) {
    var rawWeight = weightInput.value.trim();

    if (!rawWeight) {
      setResult('idle', 'Enter the measured weight to see the estimated litres remaining.');
      return;
    }

    if (!product.hasData) {
      setResult('missing', 'Conversion data is not available for ' + product.title + ' yet.');
      return;
    }

    var weight = Number(rawWeight);
    var first = product.points[0];
    var last = product.points[product.points.length - 1];

    if (!Number.isFinite(weight) || weight < first.weight || weight > last.weight) {
      setResult(
        'error',
        'Enter a weight between ' + first.weight.toFixed(2) + ' kg and ' + last.weight.toFixed(2) + ' kg.',
      );
      return;
    }

    var litres = product.points[product.points.length - 1].litres;
    for (var index = 0; index < product.points.length; index += 1) {
      var current = product.points[index];
      if (weight <= current.weight) {
        if (index === 0 || weight === current.weight) {
          litres = current.litres;
        } else {
          var previous = product.points[index - 1];
          var fraction = (weight - previous.weight) / (current.weight - previous.weight);
          litres = previous.litres + fraction * (current.litres - previous.litres);
        }
        break;
      }
    }

    var litreLabel = formatNumber(litres) + (Math.round(litres * 10) / 10 === 1 ? ' litre' : ' litres');
    setResult('success', 'Estimated ' + litreLabel + ' remaining.');
  }

  function updateUrl(handle) {
    if (!window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    params.set('product', handle);
    var query = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
  }

  function selectProduct(handle, shouldUpdateUrl) {
    var product = productsByHandle.get(handle) || products[0];
    if (!product) return;

    productSelect.value = product.handle;
    products.forEach(function (item) {
      var isSelected = item.handle === product.handle;
      item.node.dataset.selected = String(isSelected);
      var selectButton = item.node.querySelector('[data-bib-select]');
      if (selectButton) selectButton.setAttribute('aria-pressed', String(isSelected));
    });

    if (product.image) {
      selectedImage.src = product.image;
      selectedImage.alt = product.imageAlt;
      selectedMedia.hidden = false;
    } else {
      selectedImage.removeAttribute('src');
      selectedMedia.hidden = true;
    }
    selectedVendor.textContent = product.vendor;
    selectedTitle.textContent = product.title;
    selectedAvailability.textContent = product.availability;
    selectedDataStatus.textContent = product.hasData
      ? 'Approved conversion data available'
      : 'Conversion data unavailable until approved';
    if (product.url) {
      selectedLink.href = product.url;
      selectedLink.firstChild.textContent = 'View product ';
      selectedLink.hidden = false;
    } else if (fallbackUrl) {
      selectedLink.href = fallbackUrl;
      selectedLink.firstChild.textContent = 'Browse Bag in a Box products ';
      selectedLink.hidden = false;
    } else {
      selectedLink.removeAttribute('href');
      selectedLink.hidden = true;
    }

    renderReference(product);
    calculate(product);
    if (shouldUpdateUrl) updateUrl(product.handle);
  }

  productSelect.addEventListener('change', function () {
    selectProduct(productSelect.value, true);
  });

  weightInput.addEventListener('input', function () {
    var product = productsByHandle.get(productSelect.value);
    if (product) calculate(product);
    quickWeightSelect.value = '';
  });

  quickWeightSelect.addEventListener('change', function () {
    if (!quickWeightSelect.value) return;
    weightInput.value = quickWeightSelect.value;
    var product = productsByHandle.get(productSelect.value);
    if (product) calculate(product);
  });

  productNodes.forEach(function (node) {
    var button = node.querySelector('[data-bib-select]');
    if (button) {
      button.addEventListener('click', function () {
        selectProduct(node.dataset.handle, true);
      });
    }
  });

  var queryProduct = new URLSearchParams(window.location.search).get('product');
  var initialProduct = queryProduct || root.dataset.initialProduct || (products[0] && products[0].handle);
  selectProduct(initialProduct, false);
})();